import queryString from "query-string";

import { INTEGRATION_BUSINESS } from "constants/actionTypes";

import { serializeIntegrationBusiness } from "lib/serializers/integrationBusinesses";

import { URLCreatorProps } from "./types";
import {
  offlineActionCreator,
  offlineSubActionCreator,
  urlCheckAndAddIdAndAction,
} from "./lib";

interface SynchronizeProps extends URLCreatorProps {
  integrationCredentialId: string;
}

const urlCreator = ({ changesSince, id, action }: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/integration-businesses/", id, action),
    query: {
      changesSince,
    },
  });

const synchronizeRequest = offlineSubActionCreator(
  INTEGRATION_BUSINESS.SYNCHRONIZE,
  urlCreator,
  "POST",
  ({ id, action }: SynchronizeProps) => ({ id, action }),
);

export const IntegrationBusinessAction = offlineActionCreator(
  INTEGRATION_BUSINESS,
  serializeIntegrationBusiness,
  urlCreator,
  false,
);

IntegrationBusinessAction.linkToBusiness = (
  integrationBusinessId: number,
  businessId: string,
  options?: unknown,
) => ({
  type: INTEGRATION_BUSINESS.LINK_TO_BUSINESS.ACTION,
  id: integrationBusinessId,
  businessId,
  options,
});

IntegrationBusinessAction.unlinkFromBusiness = (
  integrationBusinessId: number,
  businessId: string,
  options?: unknown,
) => ({
  type: INTEGRATION_BUSINESS.UNLINK_FROM_BUSINESS.ACTION,
  id: integrationBusinessId,
  businessId,
  options,
});

IntegrationBusinessAction.synchronize = (
  integrationBusinessId: number,
  integrationCredentialId: string,
) =>
  IntegrationBusinessAction.action(
    INTEGRATION_BUSINESS.SYNCHRONIZE,
    synchronizeRequest,
    {
      id: integrationBusinessId,
      integrationCredentialId,
      action: "sync",
    },
  );
